import {
	Button,
	CaseStyle,
	ClassNameProps,
	Column,
	filterUniqueObjects,
	jsxEnglishCommaJoin,
	makeClassName,
	RelativeTimestamp,
	Row,
	stringToLocalDate,
	StyleProps,
	TruncatedText,
} from "@hex-insights/core";
import { SlimTimelineItemLoadingPlaceholder } from "../../../../Components/LoadingPlaceholder";
import { TimelinePaymentListQuery } from "../../../../Utilities";
import { ModelFormat, PaymentFormat } from "../../../Format";
import { StudentLink } from "../../../Links";
import { PaymentUtilities } from "../../../Utilities";
import { PaymentModelIcon } from "../../_General/ModelIcons";
import styles from "./styles.module.css";

export type TimelineItemProps = {
	isLoading?: boolean;
	payment: TimelinePaymentListQuery["paymentConnection"]["edges"][0]["node"] | null;
} & Partial<ClassNameProps & StyleProps>;

export function TimelineItem({ isLoading = false, payment, className, style }: TimelineItemProps) {
	if (isLoading && !payment) {
		return <SlimTimelineItemLoadingPlaceholder className={className} style={style} />;
	}

	if (!payment) {
		return null;
	}

	const issueDate = stringToLocalDate(payment.issueDate, "day");
	const students = filterUniqueObjects(
		payment.paymentLineItems.map((e) => e.invoice.contractInstallment.contract.student),
		["id"],
	);
	const totalPaymentAmount = PaymentUtilities.calculateTotalAmount(payment);

	return (
		<Button
			onClick={() => {}}
			className={makeClassName(styles["timeline-item"], "button--tile", className)}
			style={style}
		>
			<Row justify="spaced-start" align="center" horizontalSpacing="1rem">
				<PaymentModelIcon size={24} style={{ padding: "0.5rem" }} />

				<Column justify="spaced-start" verticalSpacing="0.125rem" style={{ width: "100%", minWidth: 0 }}>
					<Row justify="spaced-start">
						<TruncatedText className={styles["timeline-item__main-line"]}>
							Payment submitted for{" "}
							{jsxEnglishCommaJoin(
								students.map((e) => (
									<StudentLink key={e.id} instance={e} className="link--primary link--no-text-decoration" />
								)),
							)}
						</TruncatedText>

						<RelativeTimestamp value={issueDate} precision="day" className="timestamp nowrap" />
					</Row>

					<TruncatedText className={styles["timeline-item__preview-text"]}>
						Payment of {ModelFormat.money(totalPaymentAmount)} submitted via{" "}
						{PaymentFormat.Fields.paymentMethod(payment.paymentMethod, CaseStyle.Plain)}
					</TruncatedText>
				</Column>
			</Row>
		</Button>
	);
}
